// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// // Helper function to request geolocation permission
// const requestGeolocationPermission = () => {
//   return new Promise((resolve, reject) => {
//     if (!navigator.geolocation) {
//       reject(new Error('Geolocation is not supported by this browser.'));
//     } else {
//       navigator.geolocation.getCurrentPosition(resolve, reject, {
//         enableHighAccuracy: true,
//         timeout: 5000,
//         maximumAge: 0
//       });
//     }
//   });
// };

// // Async thunk for getting the user's location
// export const getUserLocation = createAsyncThunk(
//   'location/getUserLocation',
//   async (_, { dispatch, rejectWithValue }) => {
//     try {
//       const position = await requestGeolocationPermission();
//       return {
//         latitude: position.coords.latitude,
//         longitude: position.coords.longitude,
//       };
//     } catch (error) {
//       if (error.code === 1) {
//         // Permission denied
//         dispatch(setPermissionStatus('denied'));
//       } else if (error.code === 2) {
//         // Position unavailable
//         dispatch(setPermissionStatus('unavailable'));
//       } else {
//         // Other errors
//         dispatch(setPermissionStatus('error'));
//       }
//       return rejectWithValue(error.message || 'Failed to get location');
//     }
//   }
// );

// // Async thunk for re-requesting location permission
// export const reRequestLocationPermission = createAsyncThunk(
//   'location/reRequestLocationPermission',
//   async (_, { dispatch }) => {
//     try {
//       await dispatch(getUserLocation());
//       return true;
//     } catch (error) {
//       return false;
//     }
//   }
// );

// export const locationSlice = createSlice({
//   name: 'location',
//   initialState: {
//     coordinates: {
//       latitude: null,
//       longitude: null,
//     },
//     permissionStatus: 'unknown', // 'granted', 'denied', 'unavailable', 'error', or 'unknown'
//     error: null,
//     isLoading: false,
//   },
//   reducers: {
//     setPermissionStatus: (state, action) => {
//       state.permissionStatus = action.payload;
//     },
//     clearLocation: (state) => {
//       state.coordinates.latitude = null;
//       state.coordinates.longitude = null;
//       state.permissionStatus = 'unknown';
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(getUserLocation.pending, (state) => {
//         state.isLoading = true;
//         state.error = null;
//       })
//       .addCase(getUserLocation.fulfilled, (state, action) => {
//         state.isLoading = false;
//         state.coordinates.latitude = action.payload.latitude;
//         state.coordinates.longitude = action.payload.longitude;
//         state.permissionStatus = 'granted';
//         state.error = null;
//       })
//       .addCase(getUserLocation.rejected, (state, action) => {
//         state.isLoading = false;
//         state.error = action.payload;
//       })
//       .addCase(reRequestLocationPermission.fulfilled, (state, action) => {
//         if (!action.payload) {
//           state.permissionStatus = 'denied';
//         }
//       });
//   },
// });

// export const { setPermissionStatus, clearLocation } = locationSlice.actions;

// // Updated Selectors
// export const selectLocation = (state) => state?.location?.coordinates;
// export const selectPermissionStatus = (state) => state?.location?.permissionStatus;
// export const selectLocationError = (state) => state?.location?.error;
// export const selectLocationLoading = (state) => state?.location?.isLoading;

// export default locationSlice.reducer;


import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Helper function to request geolocation permission
const requestGeolocationPermission = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by this browser.'));
    } else {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      });
    }
  });
};

// Async thunk for getting the user's location
export const getUserLocation = createAsyncThunk(
  'location/getUserLocation',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const position = await requestGeolocationPermission();
      return {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      };
    } catch (error) {
      if (error.code === 1) {
        // Permission denied
        dispatch(setPermissionStatus('denied'));
      } else if (error.code === 2) {
        // Position unavailable
        dispatch(setPermissionStatus('unavailable'));
      } else {
        // Other errors
        dispatch(setPermissionStatus('error'));
      }
      return rejectWithValue(error.message || 'Failed to get location');
    }
  }
);

// Async thunk for re-requesting location permission
export const reRequestLocationPermission = createAsyncThunk(
  'location/reRequestLocationPermission',
  async (_, { dispatch }) => {
    try {
      await dispatch(getUserLocation());
      return true;
    } catch (error) {
      // If permission is denied, we can't automatically re-request.
      // Instead, we'll guide the user to change their settings manually.
      dispatch(setShowManualInstructions(true));
      return false;
    }
  }
);

export const locationSlice = createSlice({
  name: 'location',
  initialState: {
    coordinates: {
      latitude: null,
      longitude: null,
    },
    permissionStatus: 'unknown', // 'granted', 'denied', 'unavailable', 'error', or 'unknown'
    error: null,
    isLoading: false,
    showManualInstructions: false,
  },
  reducers: {
    setPermissionStatus: (state, action) => {
      state.permissionStatus = action.payload;
    },
    clearLocation: (state) => {
      state.coordinates.latitude = null;
      state.coordinates.longitude = null;
      state.permissionStatus = 'unknown';
      state.error = null;
    },
    setShowManualInstructions: (state, action) => {
      state.showManualInstructions = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserLocation.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getUserLocation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.coordinates.latitude = action.payload.latitude;
        state.coordinates.longitude = action.payload.longitude;
        state.permissionStatus = 'granted';
        state.error = null;
        state.showManualInstructions = false;
      })
      .addCase(getUserLocation.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(reRequestLocationPermission.fulfilled, (state, action) => {
        if (!action.payload) {
          state.permissionStatus = 'denied';
        }
      });
  },
});

export const { setPermissionStatus, clearLocation, setShowManualInstructions } = locationSlice.actions;

// Updated Selectors
export const selectLocation = (state) => state.location.coordinates;
export const selectPermissionStatus = (state) => state.location.permissionStatus;
export const selectLocationError = (state) => state.location.error;
export const selectLocationLoading = (state) => state.location.isLoading;
export const selectShowManualInstructions = (state) => state.location.showManualInstructions;

export default locationSlice.reducer;